export function isValidEmail(email) {
    const expression = /^[-.\w]+@(?![^.]{0,1}\.[a-zA-Z]{2,}$)([-a-zA-Z0-9]+\.)+[a-zA-Z]{2,}$/;
    return expression.test(email);
}